module.exports = __webpack_public_path__ + "static/media/CONTACTOMobile.edea4cd4.jpg";